export default "__VITE_ASSET__CeX_CPyT__"